import { CardContainer, Container } from "components";
import SmallCard from "components/atoms/SmallCard";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { CKEditor } from "ckeditor4-react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { getData, postData } from "actions";
import {
  API_URL_agent,
  API_URL_agentEmail,
  API_URL_department,
  API_URL_helpTopic,
  API_URL_slaplan,
  API_URL_ticketAgentCreate,
  API_URL_ticketPriority,
} from "constants/api";
import { ticketReducers } from "redux/ticketSlice";
import { slaplanReducers } from "redux/slaplanSlice";
import { helpTopicReducers } from "redux/helpTopicSlice";
import { agentReducers } from "redux/agentSlice";
import { ticketPriorityReducers } from "redux/ticketPrioritySlice";
import axios from "axios";
import { AuthContext } from "context/AuthContext";
import { departmentReducers } from "redux/departmentSlice";
import { FaPaperclip } from "react-icons/fa";
import { toast } from "react-toastify";
import { byteToKiloByte } from "utils/byteToKiloByte";

const FormTicket = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const inputRefs = useRef([]);
  const { datauser } = useContext(AuthContext);
  const [ipAddress, setIpAddress] = useState("");
  const [refreshEditor, setRefreshEditor] = useState(false);
  const [existingUser, setExistingUser] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [suggestions, setSuggestions] = useState([]);

  const {
    getTicketPriorityResult,
    getDepartmentResult,
    getSlaplanResult,
    getAgentResult,
  } = useSelector((state) => ({
    getTicketPriorityResult: state.ticketPriority.getTicketPriorityResult,
    getDepartmentResult: state.department.getDepartmentResult,
    getSlaplanResult: state.slaplan.getSlaplanResult,
    getAgentResult: state.agent.getAgentResult,
  }));

  const getSlaplan = useCallback(
    async (params) => {
      getData(
        API_URL_slaplan,
        params,
        { dispatch, redux: slaplanReducers },
        "GET_SLAPLAN"
      );
    },
    [dispatch]
  );

  const getTicketPriority = useCallback(
    async (params) => {
      getData(
        API_URL_ticketPriority,
        params,
        { dispatch, redux: ticketPriorityReducers },
        "GET_TICKETPRIORITY"
      );
    },
    [dispatch]
  );

  const getDepartment = useCallback(
    async (params) => {
      getData(
        API_URL_department,
        params,
        { dispatch, redux: departmentReducers },
        "GET_DEPARTMENT"
      );
    },
    [dispatch]
  );

  const getAgent = useCallback(
    async (params) => {
      getData(
        API_URL_agent,
        params,
        { dispatch, redux: agentReducers },
        "GET_AGENT"
      );
    },
    [dispatch]
  );

  const formik = useFormik({
    initialValues: {
      choice: "existing_user",
      email: "",
      first_name: "",
      last_name: "",
      country_code: "",
      mobile: "",
      phone_number: "",
      department: "",
      sla: "",
      duedate: "",
      assigned_to: "",
      title: "",
      body: "",
      priority: "",
      files: [],
    },
    validationSchema: Yup.object({
      choice: Yup.string().required("Choice is required"),
      department: Yup.string().required("Department is required"),
      assigned_to: Yup.string().required("Assigned To is required"),
      title: Yup.string().required("Subject is required"),
      body: Yup.string().required("Body is required"),
      priority: Yup.string().required("Priority is required"),
    }),
    onSubmit: (values) => {
      console.log(values.choice);
      if (values.choice === "new_user") {
        if (!values.email) {
          formik.setFieldError("email", "Email is required");
          return;
        }
        if (!values.first_name) {
          formik.setFieldError("first_name", "First Name is required");
          return;
        }
      }
      const formData = new FormData();
      formData.append("choice", values.choice);
      formData.append("email", values.email);
      formData.append("first_name", values.first_name);
      formData.append("last_name", values.last_name);
      formData.append("country_code", values.country_code);
      formData.append("mobile", values.mobile);
      formData.append("phone_number", values.phone_number);
      formData.append("sla", values.sla);
      formData.append("department", values.department);
      formData.append("source", 3);
      formData.append("status", 1);
      formData.append("rating", 0);
      formData.append("ratingreply", 0);
      formData.append("ip_address", "0.0.0.0");
      formData.append("duedate", values.duedate);
      formData.append("assigned_to", values.assigned_to);
      formData.append("isoverdue", 0);
      formData.append("reopened", 0);
      formData.append("isanswered", 0);
      formData.append("closed", 0);
      formData.append("is_transferred", 0);
      formData.append("approval", 0);
      formData.append("follow_up", 0);
      formData.append("agent_create", datauser.id);
      formData.append(
        "ticket_thread",
        JSON.stringify([
          { title: values.title, body: values.body, is_internal: 0 },
        ])
      );
      formData.append("priority", values.priority);
      // Menggunakan values.files untuk mengambil daftar file yang dipilih
      values.files.forEach((file, index) => {
        formData.append(`file_${index}`, file);
      });

      postData(
        API_URL_ticketAgentCreate,
        formData,
        { dispatch, redux: ticketReducers },
        "ADD_TICKET",
        () => {
          formik.resetForm();
          setRefreshEditor(!refreshEditor);
          formik.setFieldValue("body", "");
          window.location.href = "/tickets/inbox";
          navigate("/tickets/inbox");
        }
      );
    },
  });

  // Focus Input validate & submit
  const handleFormSubmit = async (event) => {
    event.preventDefault();
    await formik.validateForm();
    const firstInvalidInputRef = inputRefs.current.find((inputRef) => {
      const fieldName = inputRef.name;
      formik.setFieldTouched(fieldName, true, true);
      return formik.errors[fieldName];
    });
    if (firstInvalidInputRef) {
      firstInvalidInputRef.focus();
    } else {
      formik.handleSubmit();
    }
  };

  const handleEmailChange = async (value) => {
    const inputValue = value;

    try {
      const response = await axios.get(
        `${API_URL_agentEmail}?query=${inputValue}`
      );
      setSuggestions(response.data.suggestions);
    } catch (error) {
      console.error("Error fetching suggestions:", error);
    }
  };

  const toolbarConfig = {
    extraPlugins: "font,colorbutton,colordialog",
    removePlugins: "about,image",
    skin: "moono",
  };

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
  };

  useEffect(() => {
    axios
      .get("https://api64.ipify.org?format=json")
      .then((response) => {
        setIpAddress(response.data.ip);
      })
      .catch((error) => {
        console.error("Error fetching IP address:", error);
      });
    const params = `?limit=${999999999}&ordering=name`;
    const paramHelpTopic = `?limit=${999999999}&private=True`;
    const paramAgent = `?limit=${9999999}&role_group=!user&is_active=1&ordering=first_name`;
    getTicketPriority(params);
    getAgent(paramAgent);
    getDepartment(params);
  }, []);

  useEffect(() => {
    handleEmailChange(formik.values.email);
  }, [formik.values.email]);

  useEffect(() => {
    formik.setFieldValue("email", "");
  }, [formik.values.choice]);

  return (
    <Container>
      <CardContainer title={"Buat Ticket"}>
        <form onSubmit={handleFormSubmit}>
          <SmallCard title={"User Details:"}>
            <div className="m-5">
              <div className=" flex items-center gap-4 mb-2 border-b">
                <label className="flex items-center gap-1">
                  <input
                    type="radio"
                    name="choice"
                    value="existing_user"
                    checked={formik.values.choice === "existing_user"}
                    onChange={(e) => formik.handleChange(e)}
                  />
                  Existing User
                </label>

                <label className="flex items-center gap-1">
                  <input
                    type="radio"
                    name="choice"
                    value="new_user"
                    checked={formik.values.choice === "new_user"}
                    onChange={(e) => formik.handleChange(e)}
                  />
                  New User
                </label>

                {formik.touched.choice && formik.errors.choice && (
                  <div className="text-red-500 dark:text-red-300 text-xs">
                    {formik.errors.choice}
                  </div>
                )}
              </div>

              <div
                className={`${
                  formik.values.choice === "new_user" ? "" : "hidden"
                }`}
              >
                <div className="flex flex-wrap">
                  <div className="w-full md:w-1/3 px-2 mb-4">
                    <label className="block">
                      Email <span className="text-red-500">*</span>
                    </label>
                    <input
                      id="email"
                      name="email"
                      type="email"
                      value={formik.values.email}
                      onChange={formik.handleChange}
                      ref={(ref) => (inputRefs.current[0] = ref)}
                      className="w-full p-1 border border-gray-300 dark:text-black focus:border-blue-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                    />
                    {formik.touched.email && formik.errors.email && (
                      <div className="text-red-500 dark:text-red-300 text-xs">
                        {formik.errors.email}
                      </div>
                    )}
                  </div>

                  <div className="w-full md:w-1/3 px-2 mb-4">
                    <label className="block">
                      First name <span className="text-red-500">*</span>
                    </label>
                    <input
                      id="first_name"
                      name="first_name"
                      type="text"
                      value={formik.values.first_name}
                      onChange={formik.handleChange}
                      ref={(ref) => (inputRefs.current[1] = ref)}
                      className="w-full p-1 border border-gray-300 dark:text-black focus:border-blue-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                    />
                    {formik.touched.first_name && formik.errors.first_name && (
                      <div className="text-red-500 dark:text-red-300 text-xs">
                        {formik.errors.first_name}
                      </div>
                    )}
                  </div>

                  <div className="w-full md:w-1/3 px-2 mb-4">
                    <label className="block">Last name</label>
                    <input
                      id="last_name"
                      name="last_name"
                      type="text"
                      value={formik.values.last_name}
                      onChange={formik.handleChange}
                      ref={(ref) => (inputRefs.current[2] = ref)}
                      className="w-full p-1 border border-gray-300 dark:text-black focus:border-blue-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                    />
                    {formik.touched.last_name && formik.errors.last_name && (
                      <div className="text-red-500 dark:text-red-300 text-xs">
                        {formik.errors.last_name}
                      </div>
                    )}
                  </div>
                </div>
                <div className="px-2 grid grid-cols-1 md:grid-cols-12 gap-4">
                  <div className="col-span-12 md:col-span-4 lg:col-span-5">
                    <label className="block">Number Handphone</label>
                    <input
                      id="mobile"
                      name="mobile"
                      type="number"
                      value={formik.values.mobile}
                      onChange={formik.handleChange}
                      ref={(ref) => (inputRefs.current[3] = ref)}
                      className="w-full p-1 border border-gray-300 dark:text-black focus:border-blue-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                    />
                    {formik.touched.mobile && formik.errors.mobile && (
                      <div className="text-red-500 dark:text-red-300 text-xs">
                        {formik.errors.mobile}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div
                className={`${
                  formik.values.choice === "existing_user" ? "" : "hidden"
                }`}
              >
                <label htmlFor="link" className="block mb-1">
                  Select User Email
                  <span className="text-red-500">*</span>
                </label>

                <input
                  type="text"
                  className="w-full p-2 border border-gray-300 rounded-md mb-2"
                  placeholder="Enter email User"
                  id="custom-email-field"
                  name="email"
                  autoComplete="off"
                  aria-autocomplete="off"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                />
                <ul className="list-none max-h-60 overflow-y-auto">
                  {suggestions.map((suggest, index) => (
                    <li
                      className={`hover:bg-gray-300 bg-gray-100 py-0.5 my-1 cursor-pointer `}
                      key={index}
                      onClick={() => formik.setFieldValue("email", suggest)}
                    >
                      {suggest}
                    </li>
                  ))}
                </ul>

                {formik.touched.email && formik.errors.email && (
                  <div className="text-red-500 dark:text-red-300 text-xs">
                    {formik.errors.email}
                  </div>
                )}
              </div>
            </div>
          </SmallCard>
          <SmallCard title={"Ticket Option:"}>
            <div className="m-5">
              <div className="flex flex-wrap">
                <div className="w-full md:w-1/3 px-2 mb-4">
                  <label className="block">Topic Department:</label>
                  <select
                    id="department"
                    name="department"
                    value={formik.values.department}
                    onChange={formik.handleChange}
                    ref={(ref) => (inputRefs.current[4] = ref)}
                    className="w-full p-1 border border-gray-300 dark:text-black focus:border-blue-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                  >
                    <option value="" className="font-bold">
                      Pilih Department
                    </option>
                    {getDepartmentResult.results &&
                      getDepartmentResult.results.map((item, index) => (
                        <option key={index} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                  </select>
                  {formik.touched.department && formik.errors.department && (
                    <div className="text-red-500 dark:text-red-300 text-xs">
                      {formik.errors.department}
                    </div>
                  )}
                </div>

                <div className="w-full md:w-1/3 px-2 mb-4">
                  <label className="block">Assign to:</label>
                  <select
                    id="assigned_to"
                    name="assigned_to"
                    value={formik.values.assigned_to}
                    onChange={formik.handleChange}
                    ref={(ref) => (inputRefs.current[5] = ref)}
                    className="w-full p-1 border border-gray-300 dark:text-black focus:border-blue-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                  >
                    <option value="" className="font-bold">
                      Pilih Agent
                    </option>
                    {getAgentResult.results &&
                      getAgentResult.results.map((item, index) => (
                        <option key={index} value={item.id}>
                          {item.full_name}
                        </option>
                      ))}
                  </select>
                  {formik.touched.assigned_to && formik.errors.assigned_to && (
                    <div className="text-red-500 dark:text-red-300 text-xs">
                      {formik.errors.assigned_to}
                    </div>
                  )}
                </div>

                <div className="w-full md:w-1/3 px-2 mb-4">
                  <label className="w-24">
                    Priority: <span className="text-red-500">*</span>
                  </label>
                  <div className="w-full">
                    <select
                      id="priority"
                      name="priority"
                      value={formik.values.priority}
                      onChange={formik.handleChange}
                      ref={(ref) => (inputRefs.current[6] = ref)}
                      className="w-full p-1 border border-gray-300 dark:text-black focus:border-blue-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                    >
                      <option value="" className="font-bold">
                        Pilih Priority
                      </option>
                      {getTicketPriorityResult.results &&
                        getTicketPriorityResult.results.map((item, index) => (
                          <option key={index} value={item.id}>
                            {item.priority}
                          </option>
                        ))}
                    </select>
                    {formik.touched.priority && formik.errors.priority && (
                      <div className="text-red-500 dark:text-red-300 text-xs">
                        {formik.errors.priority}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </SmallCard>
          <SmallCard title={"Ticket Detail:"}>
            <div className="m-5">
              <div className="px-2 grid grid-cols-1 md:grid-cols-12 gap-4">
                <div className="col-span-12">
                  <div className="flex flex-col md:flex-row ">
                    <label className="w-24">
                      Subject: <span className="text-red-500">*</span>
                    </label>
                    <div className="w-full">
                      <input
                        id="title"
                        name="title"
                        type="text"
                        value={formik.values.title}
                        onChange={formik.handleChange}
                        ref={(ref) => (inputRefs.current[7] = ref)}
                        className="w-full p-1 border border-gray-300 dark:text-black focus:border-blue-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                      />
                      {formik.touched.title && formik.errors.title && (
                        <div className="text-red-500 dark:text-red-300 text-xs">
                          {formik.errors.title}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-span-12">
                  <div className="flex flex-col md:flex-row ">
                    <label className="w-24">
                      Detail: <span className="text-red-500">*</span>
                    </label>
                    <div>
                      <div className="w-full">
                        <CKEditor
                          key={refreshEditor}
                          config={toolbarConfig}
                          type="classic"
                          initData={formik.values.body}
                          onChange={(e) => {
                            formik.setFieldValue("body", e.editor.getData());
                          }}
                        />
                      </div>
                      {formik.touched.body && formik.errors.body && (
                        <div className="text-red-500 dark:text-red-300 text-xs">
                          {formik.errors.body}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-span-12">
                  <div className="flex items-center mb-2">
                    <label className="p-1 px-3 flex items-center rounded shadow-sm border bg-neutral-50 hover:bg-neutral-100 dark:bg-neutral-700 dark:border-neutral-700 text-gray-900 dark:text-white">
                      <FaPaperclip />
                      <span>Choose File [Accept Multiple]</span>
                      <input
                        type="file"
                        id="file"
                        name="file"
                        className="hidden"
                        multiple // Izinkan pengguna untuk memilih beberapa file
                        onChange={(e) => {
                          const selectedFiles = Array.from(e.target.files);
                          const maxSize = 5 * 1024 * 1024; // 5MB in bytes
                          const allowedExtensions = [
                            ".doc",
                            ".docx",
                            ".jpeg",
                            ".png",
                            ".webp",
                            ".pdf",
                            ".xls",
                            ".xlsx",
                            ".jpg",
                            ".DOC",
                            ".DOCX",
                            ".JPEG",
                            ".PNG",
                            ".WEBP",
                            ".PDF",
                            ".XLS",
                            ".XLSX",
                            ".JPG",
                          ];

                          const validFiles = selectedFiles.filter((file) => {
                            const fileExtension = file.name.split(".").pop();

                            if (file.size > maxSize) {
                              // Validasi ukuran file
                              toast.warning(
                                `File ${file.name} exceeds the size limit (5MB).`,
                                {
                                  position: "top-center",
                                  autoClose: true,
                                  hideProgressBar: true,
                                  closeOnClick: true,
                                  pauseOnHover: true,
                                  draggable: true,
                                  progress: undefined,
                                  theme: "light",
                                }
                              );
                              return false;
                            } else if (
                              !allowedExtensions.includes(
                                `.${fileExtension.toLowerCase()}`
                              )
                            ) {
                              // Validasi ekstensi file
                              toast.warning(
                                `File ${file.name} has an unsupported extension.`,
                                {
                                  position: "top-center",
                                  autoClose: true,
                                  hideProgressBar: true,
                                  closeOnClick: true,
                                  pauseOnHover: true,
                                  draggable: true,
                                  progress: undefined,
                                  theme: "light",
                                }
                              );
                              return false;
                            }

                            return true;
                          });

                          // Update the 'files' array in one go
                          formik.setFieldValue("files", [
                            ...formik.values.files,
                            ...validFiles,
                          ]);
                        }}
                      />
                    </label>
                    <p className="ml-2">
                      Each file upload is a maximum of 5Mb
                      [doc,docx,jpeg,png,webp,pdf,xls,xlsx,jpg]
                    </p>
                  </div>

                  {formik.values.files.map((file, index) => (
                    <div
                      key={index}
                      className="md:flex md:flex-row items-center justify-between bg-blue-100 dark:bg-blue-800 text-blue-500 dark:text-blue-100 p-2 rounded-lg mb-2 w-full lg:w-1/2"
                    >
                      <span className="mr-2 flex-wrap">
                        {file.name} ({byteToKiloByte(file.size)} KB)
                      </span>
                      <button
                        type="button"
                        onClick={() => {
                          // Hapus file dari daftar saat pengguna mengklik tombol
                          const updatedFiles = [...formik.values.files];
                          updatedFiles.splice(index, 1);
                          formik.setFieldValue("files", updatedFiles);
                        }}
                        className="text-red-500 hover:text-red-700 ml-2 cursor-pointer"
                      >
                        Delete
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </SmallCard>
          <div className="h-12 w-full grid items-center px-4 bg-neutral-50 dark:bg-neutral-700 border-b border-neutral-200 dark:border-neutral-600">
            <button
              type="submit"
              className="w-20 items-center p-1 px-3 rounded shadow-sm border text-white bg-blue-800 hover:bg-blue-700"
            >
              Submit
            </button>
          </div>
        </form>
      </CardContainer>
    </Container>
  );
};

export default FormTicket;
